var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { PublicKey, LAMPORTS_PER_SOL, } from "@solana/web3.js";
import * as anchor from "@coral-xyz/anchor";
import { AnchorProvider } from "@coral-xyz/anchor";
import { MarinadeUtils, Provider, } from "@sunrisestake/marinade-ts-sdk";
import { MAX_NUM_PRECISION } from "./constants.js";
import { getAccount, getAssociatedTokenAddressSync, } from "@solana/spl-token";
import BN from "bn.js";
// zero bn number
export var ZERO = new BN(0);
export var PROGRAM_ID = new PublicKey("sunzv8N3A8dRHwUBvxgRDEbWKk8t7yiHR4FLRgFsTX6");
export var zip = function (a, b, defaultB) {
    return a.map(function (k, i) {
        if (b.length <= i)
            return [k, defaultB];
        return [k, b[i]];
    });
};
export var toSol = function (lamports, precision) {
    if (precision === void 0) { precision = MAX_NUM_PRECISION; }
    return lamports.div(new BN(10).pow(new BN(precision))).toNumber() /
        (LAMPORTS_PER_SOL / Math.pow(10, precision));
};
var findProgramDerivedAddress = function (config, seed, extraSeeds) {
    if (extraSeeds === void 0) { extraSeeds = []; }
    var seeds = __spreadArray([
        config.stateAddress.toBuffer(),
        Buffer.from(seed)
    ], extraSeeds, true);
    return PublicKey.findProgramAddressSync(seeds, config.programId);
};
export var findMSolTokenAccountAuthority = function (config) {
    return findProgramDerivedAddress(config, "msol_account" /* ProgramDerivedAddressSeed.M_SOL_ACCOUNT */);
};
export var findBSolTokenAccountAuthority = function (config) {
    return findProgramDerivedAddress(config, "bsol_account" /* ProgramDerivedAddressSeed.B_SOL_ACCOUNT */);
};
export var findGSolMintAuthority = function (config) {
    return findProgramDerivedAddress(config, "gsol_mint_authority" /* ProgramDerivedAddressSeed.G_SOL_MINT_AUTHORITY */);
};
export var findEpochReportAccount = function (config) {
    return findProgramDerivedAddress(config, "epoch_report" /* ProgramDerivedAddressSeed.EPOCH_REPORT_ACCOUNT */);
};
export var findOrderUnstakeTicketAccount = function (config, epoch, index) {
    var epochBuf = Buffer.allocUnsafe(8);
    epochBuf.writeBigInt64BE(epoch, 0);
    var indexBuf = Buffer.allocUnsafe(8);
    indexBuf.writeBigInt64BE(index, 0);
    return findProgramDerivedAddress(config, "order_unstake_ticket_account" /* ProgramDerivedAddressSeed.ORDER_UNSTAKE_TICKET_ACCOUNT */, [epochBuf, indexBuf]);
};
export var findLockAccount = function (config, authority) {
    return findProgramDerivedAddress(config, "lock_account" /* ProgramDerivedAddressSeed.LOCK_ACCOUNT */, [
        authority.toBuffer(),
    ]);
};
export var findLockTokenAccount = function (config, authority) {
    return findProgramDerivedAddress(config, "lock_token_account" /* ProgramDerivedAddressSeed.LOCK_TOKEN_ACCOUNT */, [authority.toBuffer()]);
};
export var findImpactNFTMintAuthority = function (config) {
    return findProgramDerivedAddress(config, "impact_nft_mint_authority" /* ProgramDerivedAddressSeed.IMPACT_NFT_MINT_AUTHORITY */);
};
export var findImpactNFTMint = function (config, authority) {
    return findProgramDerivedAddress(config, "impact_nft_mint_account" /* ProgramDerivedAddressSeed.IMPACT_NFT_MINT_ACCOUNT */, [authority.toBuffer()]);
};
export var logKeys = function (transaction) {
    transaction.instructions.forEach(function (instruction, j) {
        instruction.keys.forEach(function (key, i) {
            console.log(j, i, key.pubkey.toBase58());
        });
    });
};
export var getTokenAccountNullable = function (connection, tokenAccountAddress) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, getAccount(connection, tokenAccountAddress).catch(function (error) {
                if (error.name === "TokenAccountNotFoundError") {
                    return null;
                }
                throw error;
            })];
    });
}); };
export var getImpactNFT = function (config, authority, provider) { return __awaiter(void 0, void 0, void 0, function () {
    var impactNFTMint, tokenAccountAddress, tokenAccount;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                impactNFTMint = findImpactNFTMint(config, authority)[0];
                tokenAccountAddress = getAssociatedTokenAddressSync(impactNFTMint, authority);
                return [4 /*yield*/, getTokenAccountNullable(provider.connection, tokenAccountAddress)];
            case 1:
                tokenAccount = _b.sent();
                return [2 /*return*/, {
                        mint: impactNFTMint,
                        tokenAccount: tokenAccountAddress,
                        exists: ((_a = tokenAccount === null || tokenAccount === void 0 ? void 0 : tokenAccount.amount) !== null && _a !== void 0 ? _a : 0) > 0,
                    }];
        }
    });
}); };
export var confirm = function (connection) { return function (txSig) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _b = (_a = connection).confirmTransaction;
                _c = [{ signature: txSig }];
                return [4 /*yield*/, connection.getLatestBlockhash()];
            case 1: return [2 /*return*/, _b.apply(_a, [__assign.apply(void 0, _c.concat([(_d.sent())]))])];
        }
    });
}); }; };
export var setUpAnchor = function () {
    // Configure the client to use the local cluster.
    var provider = AnchorProvider.env();
    anchor.setProvider(provider);
    return provider;
};
export var ZERO_BALANCE = {
    value: {
        amount: "0",
        decimals: 9,
        uiAmount: 0,
        uiAmountString: "0",
    },
};
/**
 * Find all open delayed unstake tickets for the given epoch
 * @param connection
 * @param config
 * @param epoch
 * @param expectedCount
 */
export var findAllTickets = function (connection, config, epoch, expectedCount) { return __awaiter(void 0, void 0, void 0, function () {
    var tickets, i, orderUnstakeTicketAccount, accountInfos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tickets = [];
                // get the public keys for all the accounts
                for (i = expectedCount - 1; i >= 0; i--) {
                    orderUnstakeTicketAccount = findOrderUnstakeTicketAccount(config, epoch, BigInt(i))[0];
                    tickets.push(orderUnstakeTicketAccount);
                }
                return [4 /*yield*/, connection.getMultipleAccountsInfo(tickets)];
            case 1:
                accountInfos = _a.sent();
                // remove missing accounts and return the pubkeys of the non-missing ones.
                return [2 /*return*/, accountInfos
                        .map(function (accountInfo, i) { return [
                        tickets[i],
                        accountInfo,
                    ]; })
                        .filter(function (element) {
                        return element[1] !== null;
                    })
                        .map(function (_a) {
                        var ticket = _a[0];
                        return ticket;
                    })];
        }
    });
}); };
export var proportionalBN = function (amount, numerator, denominator) {
    if (denominator.isZero()) {
        return amount;
    }
    var result = (BigInt(amount.toString()) * BigInt(numerator.toString())) /
        BigInt(denominator.toString());
    return new BN(result.toString());
};
export var getStakeAccountInfo = function (stakeAccount, anchorProvider) { return __awaiter(void 0, void 0, void 0, function () {
    var provider;
    return __generator(this, function (_a) {
        provider = new Provider(anchorProvider.connection, anchorProvider.wallet, {});
        return [2 /*return*/, MarinadeUtils.getParsedStakeAccountInfo(provider, stakeAccount)];
    });
}); };
export var getVoterAddress = function (stakeAccount, provider
// program: Program<SunriseStake>,
) { return __awaiter(void 0, void 0, void 0, function () {
    var info;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStakeAccountInfo(stakeAccount, provider)];
            case 1:
                info = _a.sent();
                if (!info.voterAddress) {
                    throw new Error("Stake account must be delegated");
                }
                return [2 /*return*/, info.voterAddress];
        }
    });
}); };
export var getValidatorIndex = function (marinadeState, voterAddress) { return __awaiter(void 0, void 0, void 0, function () {
    var validatorRecords, validatorLookupIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, marinadeState.getValidatorRecords()];
            case 1:
                validatorRecords = (_a.sent()).validatorRecords;
                validatorLookupIndex = validatorRecords.findIndex(function (_a) {
                    var validatorAccount = _a.validatorAccount;
                    return validatorAccount.equals(voterAddress);
                });
                return [2 /*return*/, validatorLookupIndex === -1
                        ? marinadeState.state.validatorSystem.validatorList.count
                        : validatorLookupIndex];
        }
    });
}); };
export var marinadeTargetReached = function (details, percentageStakeToMarinade) {
    var msolValue = details.mpDetails.msolValue;
    var lpValue = details.lpDetails.lpSolValue;
    var totalMarinade = msolValue.add(lpValue);
    var totalValue = totalMarinade.add(details.bpDetails.bsolValue);
    var limit = proportionalBN(totalValue, new BN(percentageStakeToMarinade), new BN(100));
    var lpShare = details.lpDetails.lpSolValue.muln(1000).div(totalValue).toNumber() / 10;
    // We set this to <10% because, when depositing to Marinade, the lp share
    // never actually reaches 10%. Amounts are split across both the LP and SP
    // such that the LP balance asymptotically approaches 10% without ever
    // reaching it.
    // Therefore, 9 is a healthy value. If the LP share is lower than that,
    // we should send to Marinade.
    // TODO move to a constant
    if (lpShare < 9) {
        console.log("LP share is ".concat(lpShare, "%, which is below the minimum of 10%. Should send to Marinade."));
        return false;
    }
    return totalMarinade.gt(limit);
};
//# sourceMappingURL=../../src/dist/util.js.map